import { module } from 'modujs';
import Emitter from 'tiny-emitter/instance';
import LazyLoad from "vanilla-lazyload";
export default class extends module {
    constructor(m) {
        super(m);
        Emitter.on( 'dropdown-click', this.filtersChange.bind( this ) );
        this.search = this.$( 'search' )[0];
        if( this.search ) this.search.addEventListener( 'input', this.filtersChange.bind( this ) );

        this.events = { click: { 'button': 'buttonClick', }, };
        this.container = this.$( 'container' )[0];
        this.xhr = false;


        window.onpopstate = function (event) {
            const state = event.state;
            if (state) {
                const queryString = state.query;

                console.info(state);
            }
        };
    }

    buttonClick(){
        this.container.classList.toggle( 'hidden' );
    }

    filtersChange(){
        this.el.classList.add( 'loading' );
        this.call( 'update', 'Scroll' );
        let filtersQuery = new URLSearchParams();
        [...this.el.querySelectorAll( '[data-women-filters-group]' )].forEach( filter => {
           let filterKey = filter.dataset.womenFiltersGroup;
           let filterValues = [];
            [...filter.querySelectorAll( '[data-dropdown="dropdown-item" ].active' )].forEach( el => {
                filterValues.push( el.dataset.value );
            });
            if( filterValues.length ){
                filtersQuery.append( filterKey, filterValues.join( ',' ) );
            }
        });

        if( this.search.value !== '' ){
            filtersQuery.append( 'search', this.search.value );
        }

        let url = this.el.dataset.href + '?' + filtersQuery.toString();

        window.history.pushState({ query: filtersQuery.toString() }, "", url );



        this.xhr = axios.get( url ).then( (response) => {
            this.el.classList.remove( 'loading' );
            const doc = document.createElement("div");
            doc.innerHTML = response.data;
            document.querySelector( '[data-women-results-container]' ).innerHTML = doc.querySelector( '[data-women-results-container]' ).innerHTML;

            new LazyLoad({ elements_selector : '[data-scroll-call="toggleLazy,Scroll"]', container: document.querySelector( '[data-women-results-container]' ) });
            this.call( 'update', document.querySelector( '[data-women-results-container]' ), 'app' );
            this.call('update', false, 'Scroll');
        });

    }

    fetch(){
        axios.get( this.el.href + 'page/' + this.page + this.query ).then( (response) => {

        });
    }





    init() {}
    destroy(){}
}
